import { Typography } from "antd";

import { GenericWhiteLabelsTable } from "../../../components/tables/WhiteLabelsTable";
import { WhiteLabelFormGenericForm } from "../../../components/forms/WhiteLabelForm";
import WhiteLabelsService from "../../../services/crud/WhiteLabelsService";
import WhiteLabel from "../../../models/WhiteLabels";

function WhiteLabels() {
  return (
    <div>
      <Typography.Title level={2}>White Label configurations</Typography.Title>
      <GenericWhiteLabelsTable
        actions={{ select: true, edit: true, delete: true }}
        columnFilter={(v) => ["name", "description", "actions"].includes(v?.key + "")}
        formCreate={WhiteLabelFormGenericForm}
        formEdit={WhiteLabelFormGenericForm}
        model={WhiteLabel}
        service={WhiteLabelsService}
      ></GenericWhiteLabelsTable>
    </div>
  );
}

export default WhiteLabels;
